import { ref } from 'vue';

export default function useKeepNavigationItemInView() {
    const items = ref<HTMLElement[]>([]);
    const addItem = (el, index) => {
        items.value[index] = el;
    };

    const maybeScrollToItem = (index: number) => {
        const clickedElement: HTMLElement = items.value[index];
        if (!clickedElement) {
            return;
        }
        // @ts-ignore
        clickedElement.scrollIntoViewIfNeeded && clickedElement.scrollIntoViewIfNeeded(false);
    };

    return {
        addItem,
        maybeScrollToItem,
    };
}
